import appLayout from '../layouts/AppLayout.vue'
export default [
  {
    path: '/hotels/search/kudenix',
    name: 'hotels-kudenix',
    component: () => import('../views/hotels/kudenix/agency/index.vue'),
    meta: { layout: appLayout }
  },
  {
    path: '/hotels/options/kudenix',
    name: 'hotels-options-kudenix',
    component: () => import('../views/hotels/kudenix/agency/hotelOptions.vue'),
    meta: { layout: appLayout }
  },
  {
    path: '/hotels/reserve/kudenix',
    name: 'hotels-reserve-kudenix',
    component: () => import('../views/hotels/kudenix/agency/reserve.vue'),
    meta: { layout: appLayout }
  }
]
